<template>
  <span v-if="isVisible" :title="tooltip" class="battery-level-indicator d-inline-flex align-center">
    <v-avatar :size="avatarSize" :color="color" class="white--text battery-level-indicator__avatar">
      <v-icon :small="size !== 'large'" class="white--text">{{ iconClass }}</v-icon>
    </v-avatar>
    <span v-if="showLabel" :class="['ml-1', color + '--text']">{{ statusLabel }}</span>
  </span>
</template>

<style scoped>
.battery-level-indicator {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  line-height: 1;
}

.battery-level-indicator__avatar {
  padding: 2px;
  box-sizing: border-box;
}

.battery-level-indicator :deep(.v-avatar) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0;
}

.battery-level-indicator :deep(.v-icon) {
  line-height: 1;
}
</style>

<script>
import src from './src'
export default src
</script>
